import {Component, Input} from '@angular/core';

@Component({
  selector: 'webu-search-notifications',
  templateUrl: './search-notifications-webu.html'
})
export class SearchNotificationsWebuComponent {
  @Input() dealersTooFar: boolean;
  @Input() invalidSearch: boolean;
  @Input() serverError: boolean;
}
